// extracted by mini-css-extract-plugin
module.exports = {"layout-full":"LayoutFull_layout-full__8zbHN","layout-full__container":"LayoutFull_layout-full__container__1RQ36"};